export const BlockNavigationIfPreferredPaymentMethodRequirementUnsatisfiedMessage =
    {
        modalTitle: 'Payment Method Not Selected',
        modalContent:
            'Are you sure you want to leave? You have not made a selection for your payment method.',
        primaryAction: {
            title: 'Exit',
            name: 'exit',
        },
    } as const;
